<template>
	<div style="display:flex">
		<div class="body-mid">
			<div style="background: #FFFFFF;padding-bottom: 20px;padding-top: 20px;">
				<div style="background:#E5EDFB;">
					<div
						style="width: 120px; height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;line-height: 40px;text-align: center;">
						求助列表
					</div>
				</div>
				<div class="body-mid-top">
				
				
					<div class="mid-top-right" style="justify-content: flex-start;padding: 0 15px;">
						<p style="display: flex;align-items: center;cursor: pointer;" @click="sjShaixuan">时间
						<img src='../../assets/images/shaixuan.png'
								style="margin-left: 10px;" alt=""></p>
					</div>
					<el-select v-model="value" placeholder="请选择" @change="helpsOptionChange">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				
				</div>
				<el-table :data="tableData3.data" stripe style="width: 100%;cursor: pointer;" border=""
					@cell-click='clickItem'>
					<el-table-column prop="subjectcate_name" label="学科" width="133" :resizable="false">
					</el-table-column>
				
					<el-table-column prop="title" label="名称" width="265" :resizable="false">
					</el-table-column>
				
					<el-table-column label="求助人" width="130" :resizable="false">
						<template slot-scope="scope">
							<span @click.stop="$router.push(`/geniusClub/geniusInfo?id=${scope.row.user_id}`)">
								{{scope.row.nickname}}</span>
						</template>
					</el-table-column>
					<el-table-column label="当前状态" width="150" :resizable="false">
						<!-- 1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->
						<template slot-scope="scope">
							<span v-if="scope.row.status == 1"> 待审核</span>
							<span v-if="scope.row.status == 2"> 公布中</span>
							<span v-if="scope.row.status == 3"> 已投条</span>
							<span v-if="scope.row.status == 4"> 执行中</span>
							<span v-if="scope.row.status == 5"> 已归档</span>
							<span v-if="scope.row.status == 6"> 已存挡</span>
						</template>
					</el-table-column>
				
					<el-table-column label="求助时间"  width="220" :resizable="false">
						<template slot-scope="scope">
							<span>{{timeConversion(scope.row.createtime)  }}</span>
						</template>
					</el-table-column>
				
				</el-table>
				<div style="display: flex;justify-content: center;margin-top: 15px;">
					<el-pagination background layout="prev, pager, next" :current-page='HelpshaiXuan.page'
					 @current-change='currentChange' :page-size='tableData3.per_page' :total="tableData3.total">
					</el-pagination>
				</div>
			</div>

		</div>
		<div class="body-right">
			<div @click="dialogVisible = true">
				<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span>发布</span>
			</div>
			<div style="background: #0297F8;" @click="$router.push('/zyTools/createQZtools')">
				<img src='../../assets/images/book.png' alt="" style="width: 19px;height: 19px;"><span>求助</span>
			</div>


		</div>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="$router.push('/projectNeed/releaseNeed')"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					项目需求池
				</div>
				<div
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
	</div>
</template>
<script>
	export default {
		props:{
			checked:{
				type:Object
			},
			keyWord:{
				type:String
			}
		},
		data() {
			return {
				dialogVisible: false,
				activeTopType: '',
				tableData3: [],

				options: [{
					value: 2,
					label: '公布中'
				}, {
					value: 3,
					label: '已投条'
				}, {
					value: 4,
					label: '执行中'
				}, {
					value: 5,
					label: '已归档'
				}, {
					value: 6,
					label: '已存挡'
				}],
				value: '',
				HelpshaiXuan: {
					tags: [],
					subjectcate_ids: [],
					industry_ids: [],
					stage_ids: [],
					status: '',
					keywords: '',
					page: 1,
					order: ''
				},
				tableData3:[]
			}
		},
		watch:{
			checked:{
				handler(newValue,oldValue){
					this.HelpshaiXuan.subjectcate_ids = newValue.checkedXK
					this.HelpshaiXuan.tags = newValue.checkedJL
					this.HelpshaiXuan.industry_ids = newValue.checkedHY
					this.HelpshaiXuan.stage_ids = newValue.checkedJD
					this.getToolsHelpList()
					console.log(1);
				},
				deep: true,
			},
			keyWord:{
				handler(newValue,oldValue){    
					this.HelpshaiXuan.keywords = newValue
					this.getToolsHelpList()
				},
			},
		},
		created() {
			this.getToolsHelpList()
		},
		methods: {
			currentChange(e){
				this.shaiXuan.page = e
				this.getToolsHelpList()
			},
			async getToolsHelpList(type) {
					let list = await this.$api.schemeHelphelpList({
						...this.HelpshaiXuan
					})
					this.tableData3 = list.data
			},
			sjShaixuan(){
				this.HelpshaiXuan.order == 'id desc' ? this.HelpshaiXuan.order = 'id asc' : this.HelpshaiXuan.order = 'id desc'
				this.getToolsHelpList()
			},
			clickItem(column) {
				console.log(column)
				this.$router.push(`/solutionDetail/QZdetail?id=${column.id}`)
			},
			handleChange(val) {
				console.log(val);
			},
			helpsOptionChange(e){
				this.HelpshaiXuan.status = e
				this.getToolsHelpList()
			},
		}
	}
</script>
<style scoped lang="less">
	/deep/.el-table__cell {
		color: #222222;
		text-align: center;
	}

	/deep/.el-input__inner {
		color: #222222;
	}

	/deep/.el-input__inner::placeholder {
		color: black !important;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}

	.table {
		.table-item {
			align-items: center;
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			height: 55px;

		}

	}

	.pointer {
		p {
			cursor: pointer;
			margin-bottom: 3px;
		}

		p:hover {
			color: #0052D9;
		}
	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}

	/deep/.el-dialog__title {
		font-size: 20px;
		text-align: center;
		font-weight: bold;
	}

	.body-person-item {
		width: 151px;
		height: 270px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {
		padding-top: 30px;
		margin-top: 20px;
		width: 100%;
		height: 515px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.body-mid-footer {
		width: 95%;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	.main-item {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
	}

	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;

	}

	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;

		justify-content: flex-start;
	}

	.main-item {
		margin: 13px;
		margin-left: 18px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}

	.activeTop {
		color: white;
		background: #0052D9;
	}

	.mid-top-right {
		justify-content: space-around;
		display: flex;
		width: 580px;

		&>div {
			cursor: pointer;
			width: 100px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			border: 1px solid #D2D2D2;
		}
	}

	.body-mid-top {
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 20px;
		padding-right: 20px;
	}

	.body-mid {
		margin: 0 20px;
		width: 900px;
		box-sizing: border-box;
	}
</style>